import { DIGIT_ROLL_EASING } from './digit-roll'

/** A single, interruptible fill animation in the element's owning window. */
export class WidgetProgressAnimator {
  private animation?: Animation
  private context = ''
  private previous: number | undefined

  constructor(private readonly node: HTMLElement) {
    node.classList.add('widget-progress-motion')
    node.style.width = '100%'
    node.style.transformOrigin = 'left center'
  }

  update(value: number, context: string, animate: boolean): void {
    const ratio = Number.isFinite(value) ? Math.max(0, Math.min(1, value)) : 0
    const moving = animate && this.context === context && this.previous !== undefined && this.node.getClientRects().length > 0
    this.context = context
    if (ratio === this.previous && moving) return
    const from = this.node.ownerDocument.defaultView?.getComputedStyle(this.node).transform || 'none'
    this.cancel()
    const transform = `scaleX(${ratio})`
    this.node.style.transform = transform
    if (moving && this.node.animate) {
      const animation = this.node.animate([{ transform: from }, { transform }], {
        duration: 420, easing: DIGIT_ROLL_EASING,
      })
      this.animation = animation
      animation.onfinish = () => { if (this.animation === animation) this.animation = undefined }
    }
    this.previous = ratio
  }

  settle(): void { this.cancel() }
  reset(): void { this.cancel(); this.previous = undefined }
  private cancel(): void {
    if (this.animation) { this.animation.onfinish = null; this.animation.cancel(); this.animation = undefined }
  }
  destroy(): void { this.cancel() }
}
